<template>
  <div style="overflow-y: auto;">
    <div class="box-center-content">
      <template v-if="tenantLog.fpi.data.length">
        <div class="activity-card" v-for="(logItem, i) in tenantLog.fpi.data" :key="i">
          <div class="activity-card-header">
            <span>
              <i class="el-icon-edit-outline c-w-30"></i>
              {{ logItem.title }}
            </span>
            <span>{{ logItem.createTime }}</span>
          </div>
          <div class="activity-card-content">
            <div class="c-flex c_flex_between" v-if="logItem.opType">
              <div>
                <span>{{ logItem.opType }}</span>
              </div>
              <el-button
                title="查看错误日志"
                icon="el-icon-s-release"
                circle
                v-if="logItem.exception || logItem.exceptionMsg || logItem.formData"
                @click="
                  exception.exceptionMsg = logItem.exceptionMsg
                    ? logItem.exceptionMsg.replace(/(\r\n|\n|\r)/gm, '<br />')
                    : '';
                  exception.exception = logItem.exception
                    ? logItem.exception.replace(/(\r\n|\n|\r)/gm, '<br />')
                    : '';
                  exception.formData = $util.isJson(logItem.formData)
                    ? JSON.parse(logItem.formData)
                    : '';
                  exception.preFormData = $util.isJson(logItem.preFormData)
                    ? JSON.parse(logItem.preFormData)
                    : '';
                  exception.exts = logItem.exts ? logItem.exts : '';
                  exception.show = true;
                "
              ></el-button>
            </div>
            <div v-if="logItem.createUser">操作人id：{{ logItem.createUser }}</div>
          </div>
          <div class="activity-card-footer">
            <span>操作人：{{ logItem.createUserName }}</span>
          </div>
        </div>
      </template>
      <div class="activity-card" v-else>
        <div class="activity-card-header">暂无业务跟踪记录</div>
      </div>
    </div>

    <el-dialog
      title="业务跟踪"
      :modal="false"
      :visible.sync="exception.show"
      style="margin-top: 10vh;"
      class="exception"
      @close="exception.show = false"
    >
      <div>
        <el-tabs v-model="exception.active">
          <el-tab-pane label="exceptionMsg" name="exceptionMsg">
            <div v-html="exception.exceptionMsg"></div>
          </el-tab-pane>
          <el-tab-pane label="exception" name="exception">
            <div v-html="exception.exception"></div>
          </el-tab-pane>
          <el-tab-pane label="formData" name="formData">
            <json-viewer :value="exception.formData" :expand-depth="4" copyable sort></json-viewer>
          </el-tab-pane>
          <el-tab-pane label="preFormData" name="preFormData">
            <json-viewer
              :value="exception.preFormData"
              :expand-depth="4"
              copyable
              sort
            ></json-viewer>
          </el-tab-pane>
          <el-tab-pane label="exts" name="exts">
            <json-viewer :value="exception.exts" :expand-depth="4" copyable sort></json-viewer>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    params: {
      type: Object
    }
  },
  data() {
    return {
      //业务跟踪列表
      tenantLog: {
        fpi: {
          data: []
        }
      },
      // 异常日志弹窗
      exception: {
        exceptionMsg: '',
        exception: '',
        show: false,
        active: 'exceptionMsg'
      }
    };
  },
  created() {
    this.getStackTraceLog();
  },
  methods: {
    getStackTraceLog() {
      if (this.params.sid || this.params.smodule) {
        this.osg.ajax(
          'tenantLog/query.do',
          {
            sid: this.params.sid,
            smodule: this.params.smodule,
            sortField: this.params.sortField || 'createTime',
            sortOrder: this.params.sortOrder || 'desc',
            _all: '1'
          },
          res => {
            this.tenantLog.fpi = res;
            this.$forceUpdate();
          },
          { noload: true }
        );
      }
    }
  }
};
</script>
